<template>
    <div id="app">
        <sidebar v-show="sidebar">
            <navigation></navigation>
            <img slot="logo" src="./assets/images/logo.png" />
        </sidebar>
        <the-header v-show="header"></the-header>
        <topbar v-show="sidebar"></topbar>
        <main class="main" :class="{ 'has-no-sidebar': !sidebar }">
            <div class="container-fluid" v-if="sidebar">
                <router-view></router-view>
            </div>
            <router-view v-else></router-view>
            <modal v-if="showRemoveScenarioDialog" v-on:close="closeRemoveScenarioDialog">
                <h2>Remove scenario</h2>
                <p>
                    Are you sure you want to remove '{{ scenarioToRemove.name }}' from your list of
                    scenarios?
                </p>
                <div class="row">
                    <button class="button--primary no-margin margin-right" @click="removeScenario">
                        Remove
                    </button>
                    <button class="button--link no-margin" @click="closeRemoveScenarioDialog">
                        Cancel
                    </button>
                </div>
            </modal>
        </main>
        <the-footer v-if="!sidebar"></the-footer>
    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

import Navigation from './components/Navigation';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import TheHeader from './components/TheHeader';
import TheFooter from './components/TheFooter';
import Modal from './components/Modal';
import { Watch } from 'vue-property-decorator';

@Component({
    components: { TheHeader },
})
export default class App extends Vue {
    name = 'app';

    /**
     * Confirmation dialog for removing a scenario
     * @type {boolean}
     */
    showRemoveScenarioDialog = false;
    scenarioToRemove = undefined;

    @Watch('$route')
    onRouteChanged(to, from) {
        if (from.name === 'Login' && to.meta.auth) {
            // We came here after logging in, get user data
            this.fetchUserData();
        }
    }

    fetchUserData() {
        let share = localStorage.getItem('share_token');
        if (share) {
            this.$store.dispatch('getSharedScenario', share);
        }

        this.$store.dispatch('getUnitProfilesFromLocalStorage');
        this.$store.dispatch('getSettingsFromLocalStorage');
        this.$store.dispatch('getUnitFromLocalStorage');
        this.$store.dispatch('getUnitProfiles');
        this.$store.dispatch('fetchMotorTypes');
        this.$store.dispatch('fetchSavedScenarios');
        this.$store.dispatch('fetchSettings');
    }

    created() {
        this.fetchUserData();
    }

    mounted() {
        this.$eventHub.$on('remove-scenario', id => {
            this.showRemoveScenarioDialog = true;
            this.scenarioToRemove = id;
        });
    }

    closeRemoveScenarioDialog() {
        this.showRemoveScenarioDialog = false;
        this.scenarioToRemove = undefined;
    }

    removeScenario() {
        let scenario = this.scenarioToRemove;
        if (scenario !== undefined) {
            this.$store.dispatch('removeScenario', scenario.id);

            this.scenarioToRemove = undefined;
        }

        if (this.$route.path.indexOf(scenario.id) > -1) {
            if (this.$route.path !== '/scenarios')
                this.$router.push({
                    path: '/scenarios',
                });
        }
        this.closeRemoveScenarioDialog();
    }

    get sidebar() {
        return this.$route.meta && !this.$route.meta.hideSidebar;
    }

    get header() {
        return this.$route.meta && this.$route.meta.showHeader;
    }
}
</script>

<!-- Import SCSS boilerplate -->
<style src="./assets/css/styles.scss" lang="scss"></style>
